import { useSearchParams } from 'react-router-dom';
import { MonthStepper, PageFrame, shiftMonth } from '@eo/shared';

import { PortfolioPicker } from './PortfolioPicker';
import type { CapacityChromeProps } from './types';

// Rendered in `<Page>`'s header slot, so the page still names itself while the
// report is loading or after it fails. Refresh is a command, so it lives in the
// content, not here.
export function CapacityChrome({ data, isAdmin }: CapacityChromeProps) {
  const [, setSearchParams] = useSearchParams();

  const onMonthShift = (delta: number) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set('month', shiftMonth(data.month, delta));
      return params;
    });
  };

  return (
    <PageFrame
      title="Capacity"
      subtitle="Budgets, actuals, and team capacity from ClickUp time entries."
      controls={
        // The picker lists the report's portfolios, so it joins the month once
        // the first report has arrived.
        <div className="flex flex-col items-start gap-3">
          <MonthStepper month={data.month} onShift={onMonthShift} />
          {isAdmin && data.report && <PortfolioPicker report={data.report} />}
        </div>
      }
    />
  );
}
